import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cube-debug-panel',
  templateUrl: './debug-panel.component.html',
  styleUrls: ['./debug-panel.component.scss'],
  standalone: false,
})
export class DebugPanelComponent implements OnChanges, AfterViewInit {
  @ViewChild('debugPanel', { read: ElementRef })
  debugPanel: ElementRef<HTMLElement>;
  @ViewChild('gotoButton', { read: ElementRef })
  gotoButton: ElementRef<HTMLElement>;

  @Input() form: FormGroup;
  @Input() levelNamesList: string[];
  @Input() model: any;
  @Input() options: any;

  debugSettings: DebugSettings;
  isAfterViewInit: boolean = false;
  isJsonLoading: boolean = false; // NOTE: For refreshing ngx-json-viewer data
  isLoaderVisible: boolean = false;
  isToggleJsonExpansionDisabled: boolean = false;
  previousScrollPosition?: number;

  private scrollContainerEl;

  constructor() {
    this.isLoaderVisible = true;
    const debugSettings = this.getDebugSettingsFromSession();
    if (debugSettings) {
      this.debugSettings = debugSettings;
    } else {
      this.debugSettings = this.createDebugSettings();
      this.setDebugSettingsToSession();
    }
    this.isLoaderVisible = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // NOTE: For refreshing ngx-json-viewer data
    this.isLoaderVisible = true;
    this.isJsonLoading = true;
    setTimeout(() => {
      this.isJsonLoading = false;
      this.isLoaderVisible = false;
    }, 1000);
  }

  ngAfterViewInit(): void {
    this.isAfterViewInit = true;
    this.scrollContainerEl =
      this.gotoButton.nativeElement.offsetParent?.children[2];
  }

  onClickGotoButton(): void {
    if (this.previousScrollPosition) {
      // Go back
      this.scrollContainerEl.scrollTop = this.previousScrollPosition;
      delete this.previousScrollPosition;
    } else {
      // Go to debug panel
      if (
        this.scrollContainerEl.scrollTop <
        this.debugPanel.nativeElement.offsetTop
      ) {
        this.previousScrollPosition = this.scrollContainerEl.scrollTop;
      }
      this.debugPanel.nativeElement.scrollIntoView();
    }
  }

  onClickToggleJsonExpansion(isJsonExpanded: boolean): void {
    this.isLoaderVisible = true;
    this.isToggleJsonExpansionDisabled = true;
    this.debugSettings.isJsonExpanded = isJsonExpanded;
    this.setDebugSettingsToSession();

    setTimeout(() => {
      this.isToggleJsonExpansionDisabled = false;
      this.isLoaderVisible = false;
    }, 2000);
  }

  onExpandedChangePanel(isPanelExpanded: boolean): void {
    this.isLoaderVisible = true;
    this.debugSettings.isPanelExpanded = isPanelExpanded;
    this.setDebugSettingsToSession();
    this.isLoaderVisible = false;
  }

  onSelectedIndexChangeTab(selectedTabIndex: number): void {
    this.isLoaderVisible = true;
    this.debugSettings.selectedTabIndex = selectedTabIndex;
    this.setDebugSettingsToSession();
    this.isLoaderVisible = false;
  }

  private createDebugSettings(): DebugSettings {
    return {
      isJsonExpanded: true,
      isPanelExpanded: false,
      selectedTabIndex: 0,
    };
  }

  private getDebugSettingsFromSession(): DebugSettings {
    const debugSettings = sessionStorage.getItem('debugSettings');

    if (!debugSettings) return;

    return JSON.parse(debugSettings);
  }

  private setDebugSettingsToSession(): void {
    sessionStorage.setItem('debugSettings', JSON.stringify(this.debugSettings));
  }
}

interface DebugSettings {
  isJsonExpanded: boolean;
  isPanelExpanded: boolean;
  selectedTabIndex: number;
}
